
import Vue from 'vue';
import App from './src/app';
import './assets/style/reset.css';

new Vue({
  el: '#vue-body',
  components: {
    App,
  },
  template: '<App/>',
  render(createElement) {
    return createElement(App);
  },
});
